import { render, staticRenderFns } from "./Game6-1.vue?vue&type=template&id=cea35d70&scoped=true&"
import script from "./Game6-1.vue?vue&type=script&lang=js&"
export * from "./Game6-1.vue?vue&type=script&lang=js&"
import style0 from "./Game6-1.vue?vue&type=style&index=0&id=cea35d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea35d70",
  null
  
)

export default component.exports